/* global $ */
/* eslint-disable */
import Masonry from 'masonry-layout';
import customSelect from 'custom-select';
import { debounce } from 'lodash';

// Video handler.
import { videoHandler } from './video';

// Track the msnry instance.
// Allows us to call reflow where needed.
let msnry;

/**
 * Hover helper.
 */
function addActiveOnHover() {
  $('.mason-item').each((i, elem) => {
    $('.overlay-link', elem).on('mouseenter', () => {
      $(elem).addClass('active');
    });
  
    $('.overlay-link', elem).on('mouseleave', () => {
      $(elem).removeClass('active');
    });
  });
}

function callMasonry() {
  msnry = new Masonry('.mason-list', {
    itemSelector: '.mason-item',
    // gutter: '.mason-gutter-sizer',
    // fitWidth: true,
    columnWidth: '.mason-sizer',
    percentPosition: true
  });
}

/**
 * Mutation observer bundled cb.
 * If something needs to happen after an ajax call add it here.
 */
function observeCb(mutationsList) {
  mutationsList.forEach((mutation) => {
    if (mutation.type === 'childList') {
      callMasonry(); // Reinitialize masonry.
      addActiveOnHover();
      videoHandler();
    }
  });
}

if (document.getElementById('sftp-results') != undefined) {
  // Init.
  callMasonry();
  addActiveOnHover();

  const mySelects = customSelect('select');
  const sfpSelects = document.getElementsByClassName('sf-input-select');

  $('.searchandfilter').append('<button type="submit"></button>');
  $('.searchandfilter [type="submit"]').hide();

  $('.custom-select-opener').append('<i class="wec-icon-arrow-harsh-down"></i>');

  for (let i = 0; i < mySelects.length; i += 1) {
    // fix z-index issue on stack
    // adds .top-select to first select
    if (i === 0) {
      mySelects[i].container.classList.add('top-select');
    }
    mySelects[i].select.addEventListener('change', (e) => {
      $('.searchandfilter [type="submit"]').click();
    });
  }

  // hacky way to handle masonry reflow after ajax call
  function observeChange() {
    const targetNode = document.getElementById('sftp-results');
    const observerOptions = {
      childList: true,
      subtree: true,
    };
    const observer = new MutationObserver(observeCb);
    observer.observe(targetNode, observerOptions);
  }
  observeChange();

  // Resize.
  $(window).on('resize', debounce(() => {
    msnry.layout();
  }, 300));

  // Listen for custom a11y font size event and reflow masonry.
  document.addEventListener('a11y-toggle-fontsize-change', () => {
    msnry.layout();
  }
  );
}
/* eslint-enable */
